export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-1087.000000, -17743.000000)">
                    <g id="编组-58" transform="translate(449.000000, 16856.000000)">
                        <g id="重播" transform="translate(638.000000, 887.000000)">
                            <circle id="椭圆形" fillOpacity={props?.fillOpacity || '0.081404'} fill={props?.fill || '#000000'} cx="17" cy="17" r="17"></circle>
                            <path
                                d="M16.9144033,12.1711933 C13.6479686,12.1711933 11,14.8191619 11,18.0855967 C11,21.3520314 13.6479686,24 16.9144033,24 C20.1808381,24 22.8288067,21.3520314 22.8288067,18.0855967 C22.8288067,16.6797595 22.3383113,15.3884836 21.5191184,14.3735669"
                                id="路径"
                                stroke="#1A1A1A"
                                strokeWidth="2"
                                opacity="0.8"
                                strokeLinecap="round"
                            ></path>
                            <polyline
                                id="路径"
                                stroke="#1A1A1A"
                                strokeWidth="2"
                                opacity="0.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                transform="translate(15.383542, 12.386505) rotate(-48.000000) translate(-15.383542, -12.386505) "
                                points="17.0733717 10.6966752 17.0733717 14.0763342 13.6937126 14.0763342"
                            ></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
